export default {
  namespaced: true,

  state: {
    isLoading: true,
    backupsIsLoading: true,
    hasError: false,
    hasDetails: false,
    list: [],
    backups: [],
    objects: [],
    updateKey: 0,
    selected: [],
    quota: false,
    resourcesLeft: false,
    secret: '',
    activeQuota: false,
    types: '',
    current: [],
    currentBackup: false,
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    BACKUP_IS_LOADING(state, bool) {
      state.backupsIsLoading = bool;
    },

    HAS_ERROR(state, bool) {
      state.hasError = bool;
    },

    HAS_DETAILS(state, bool) {
      state.hasDetails = bool;
    },

    SET(state, volumeStore) {
      state.list = volumeStore;
    },

    SET_TYPES(state, volumeStore) {
      state.types = volumeStore;
    },

    SET_BACKUPS(state, volumeStore) {
      state.backups = volumeStore;
    },

    ADD(state, volumeStore) {
      state.list.push(volumeStore);
    },

    RENEW(state, volumeStore) {
      state.list = volumeStore;
    },

    SET_CURRENT(state, volumeStore) {
      state.current = volumeStore;
    },

    SET_CURRENT_VOLUME_BACKUP(state, volumeStore) {
      state.currentBackup = volumeStore;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    UPDATE(state, volumeStore) {
        const item = state.list.find(item => item.id === volumeStore.id);
        if (item && item.updateKey) {
          item.updateKey += 1;
        }
        if (item && !item.updateKey) {
          item.updateKey = 0;
        }
        Object.assign(item, volumeStore);
    },

    UPDATE_VOLUME_BACKUP(state, volumeStore) {
        const item = state.backups.find(item => item.id === volumeStore.id);
        if (item && item.updateKey) {
          item.updateKey += 1;
        }
        if (item && !item.updateKey) {
          item.updateKey = 0;
        }
        Object.assign(item, volumeStore);
    },

    UPDATE_SINGLE(state, resource) {
        let item = '';
        if (typeof(resource) === 'object') {
            item = state.list.find(item => item.id === resource.id);
          } else {
            item = state.list.find(item => item.id === resource);
          }
        if (item) {
          if (!item.singleKey) {
            item.singleKey = 0;
          }
          item.singleKey += 1;
          Object.assign(item, resource);
        } else {
          state.list.push(resource);
        }
    },

    UPDATE_TRANFERS(state, transfer) {
        const item = state.list.find(item => item.id === transfer.transfer_data.volume_id);
        Object.assign(item, transfer);
    },

    SET_SECRET(state, secret) {
      state.secret = secret;
    },

    SET_QUOTA(state, resources) {
      state.quota = resources;
    },

    SET_LEFT(state, resources) {
      state.resourcesLeft = resources;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    ACTIVE_QUOTA(state, bool) {
      state.activeQuota = bool;
    },
  },

  actions: {
    SET(context, volumeStore) {
      context.commit('SET', volumeStore);
    },

    ADD(context, volumeStore) {
      context.commit('ADD', volumeStore);
    },

    RENEW(context, volumeStore) {
      context.commit('RENEW', volumeStore);
    },

    SET_CURRENT(context, volumeStore) {
      context.commit('SET_CURRENT', volumeStore);
    },

    SET_QUOTA(context, volumeStore) {
      context.commit('SET_QUOTA', volumeStore);
    },

    SET_LEFT(context, volumeStore) {
      context.commit('SET_LEFT', volumeStore);
    },

    SET_SELECTED(context, resources) {
      context.commit('SET_SELECTED', resources);
    },
  }
}
